<template>
  <div class="imgList3n">
    <div class="g-box">
      <div class="imgList3n-list">
        <div v-for="(item, index) in list" :key="index" class="list-item">
          <div
            class="list-img"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
          ></div>
          <div class="list-text">
            <p>{{ item.title }}</p>
            <p>{{ item.tips }}</p>
          </div>
        </div>
      </div>
      <el-pagination
        @current-change="onCurrentChange"
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        class="m-pagination"
      />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      pageSize: 6
    };
  },
  components: {},
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    }
  }
};
</script>
<style lang="less">
.imgList3n {
  padding: 109px 0;
}
.imgList3n-list {
  display: flex;
  flex-wrap: wrap;
  .list-item {
    width: 33.33%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 60px;
  }
  .list-img {
    width: 300px;
    height: 212px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .list-text {
    color: #606060;
    font-size: 16px;
    line-height: 22px;
    margin-top: 26px;
    text-align: center;
  }
}
</style>
